export default __webpack_public_path__ + "static/media/screen5.0f9d01e7.png";